<script lang="ts">
	import { HTMLText } from '@atoms';
	import { Theme } from '@tools';

	let {
		data
	}: {
		data: {
			id: string;
			_modelApiKey: string;
			path: string;
			title: string;
			colorTheme: string;
			preview: string;
		};
	} = $props();

	const theme = new Theme(data.colorTheme);
</script>

<a class="container" href={data.path} style={theme.css}>
	<p class="text:body-alt">Festival</p>
	<h5 class="title text:h4">{data.title}</h5>
	<p><HTMLText text={data.preview} /></p>
	<div class="button:pill">Se mere</div>
</a>

<style lang="scss">
	.container {
		grid-column: 1 / -1;
		display: flex;
		align-items: start;
		flex-direction: column;
		background-color: var(--theme-primary);
		color: var(--theme-foreground);
		padding: $gap5;
		gap: $gap4;
		text-decoration: none;

		@include md {
			padding: $gap5 $gap6;
		}
	}

	div {
		margin-left: auto;
	}
</style>
